import { Component, inject } from '@angular/core';
import {Destroyed} from './utils/directives/destroyed.directive';
import {MatDialog} from '@angular/material/dialog';
import {interval} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SwUpdate, VersionEvent} from '@angular/service-worker';
import {DialogRefreshAppComponent} from './utils/dialog/dialog-refresh-app/dialog-refresh-app.component';
import { RouterOutlet } from '@angular/router';
import { EnvInfoComponent } from './components/env-info/env-info.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [EnvInfoComponent, RouterOutlet]
})
export class AppComponent extends Destroyed {
    private readonly swUpdate = inject(SwUpdate);
    private readonly dialog = inject(MatDialog);

    private popupAlreadyOpened = false;

    constructor() {
        super();
        this.initializeSw();
    }

    initializeSw() {
        try {
            const minutes = 300000;
            const every5Mins$ = interval(minutes);
            if (this.swUpdate.isEnabled) {
                this.swUpdate.checkForUpdate();
                every5Mins$
                    .pipe(takeUntil(this.destroyed))
                    .subscribe(() => {
                        if (!this.popupAlreadyOpened) {
                            this.swUpdate.checkForUpdate().then();
                        }
                    });

                this.swUpdate.versionUpdates.pipe(takeUntil(this.destroyed)).subscribe((value: VersionEvent) => {
                    if (value.type === 'VERSION_READY' && !this.popupAlreadyOpened) {
                        this.popupAlreadyOpened = true;
                        const dialogRef = this.dialog.open(DialogRefreshAppComponent);
                        dialogRef.afterClosed().pipe(takeUntil(this.destroyed)).subscribe(() => {
                            this.popupAlreadyOpened = false;
                            this.swUpdate.activateUpdate().then(() => {
                                //Perform your action here
                                window.location.reload();
                            });
                        });
                    }
                });
            }
        } catch (e) { /* empty */
        }
    }
}
